import { DashboardScope } from 'mormaii-web-presentation/dashboard'
import type { ViewFactory } from 'wdc-cube-solid'

import { DashboardView } from './v-dashboard'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(DashboardScope, DashboardView)
}

export { DashboardView }
